//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as samOrderApi from '@/api/samOrderApi';
export default {
  name: 'SamOrderDetail',
  data: function data() {
    return {
      visible: false,
      loading: false,
      detail: {
        baseInfo: {},
        receiverInfo: {},
        orderDetail: []
      },
      integralLoading: false,
      integralLogs: [],
      currentOrderNo: ''
    };
  },
  computed: {
    baseInfo: function baseInfo() {
      return this.detail && this.detail.baseInfo ? this.detail.baseInfo : {};
    },
    receiverInfo: function receiverInfo() {
      return this.detail && this.detail.receiverInfo ? this.detail.receiverInfo : {};
    },
    tradeInfo: function tradeInfo() {
      return this.detail && this.detail.tradeInfo ? this.detail.tradeInfo : {};
    }
  },
  methods: {
    getEmptyDetail: function getEmptyDetail() {
      return {
        baseInfo: {},
        receiverInfo: {},
        orderDetail: []
      };
    },
    open: function open(orderNo) {
      var _this = this;
      var no = orderNo || this.detail && (this.detail.orderNo || this.detail.samOrderNo);
      if (!no) {
        this.$message.warning('订单号缺失');
        return;
      }
      this.visible = true;
      this.loading = true;
      this.detail = this.getEmptyDetail();
      this.currentOrderNo = no;
      this.integralLogs = [];
      this.integralLoading = true;
      samOrderApi.getSamOrderDetail(no).then(function (res) {
        var root = res && res.data ? res.data : res || {};
        var d = root && root.data ? root.data : root;
        _this.detail = d || _this.getEmptyDetail();
      }).catch(function () {
        _this.detail = _this.getEmptyDetail();
      }).finally(function () {
        _this.loading = false;
      });
      this.loadIntegralLog(no);
    },
    loadIntegralLog: function loadIntegralLog(orderNo) {
      var _this2 = this;
      this.integralLoading = true;
      this.integralLogs = [];
      samOrderApi.getIntegralLog(orderNo).then(function (res) {
        if (Array.isArray(res)) {
          _this2.integralLogs = res;
          return;
        }
        if (res && Array.isArray(res.list)) {
          _this2.integralLogs = res.list;
          return;
        }
        if (res && Array.isArray(res.data)) {
          _this2.integralLogs = res.data;
          return;
        }
        _this2.integralLogs = [];
      }).catch(function () {
        _this2.integralLogs = [];
      }).finally(function () {
        _this2.integralLoading = false;
      });
    },
    getByKeys: function getByKeys(obj) {
      var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '--';
      if (!obj || !Array.isArray(keys)) return fallback;
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') return obj[key];
      }
      return fallback;
    },
    formatMoney: function formatMoney(val) {
      if (val === undefined || val === null || val === '') return '--';
      return "\xA5".concat(val);
    },
    formatMinusMoney: function formatMinusMoney(val) {
      if (val === undefined || val === null || val === '') return '--';
      return "-\xA5".concat(val);
    },
    formatTradeType: function formatTradeType(val) {
      var map = {
        1: '发放',
        2: '回收',
        3: '使用',
        4: '过期',
        5: '退回',
        6: '转出',
        7: '转入'
      };
      var key = Number(val);
      return map[key] || '--';
    },
    formatChildOrderStatus: function formatChildOrderStatus(val) {
      var map = {
        1: '已完成',
        2: '已创建',
        3: '已确认',
        4: '已取消',
        5: '已退款',
        6: '已确认收货',
        7: '已发货',
        8: '已删除'
      };
      var key = Number(val);
      return map[key] || '--';
    },
    formatReceiptStatus: function formatReceiptStatus(val) {
      var map = {
        1: '已收货',
        2: '未收货'
      };
      var key = Number(val);
      return map[key] || '--';
    },
    formatDeliveredStatus: function formatDeliveredStatus(val) {
      var map = {
        1: '已发货',
        2: '配送中',
        3: '待催送'
      };
      var key = Number(val);
      return map[key] || '--';
    },
    handleClose: function handleClose() {
      this.visible = false;
      this.detail = this.getEmptyDetail();
      this.integralLogs = [];
    }
  }
};